import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Slide from '@mui/material/Slide';
import submitTestAPI from '../../../../services/api/fytnServices';
import { toast, ToastContainer } from "react-toastify";

const TOAST_ID = 'unique-toast-id';

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

export default function AlertDialogSlidex({ open, 
    setOpen, name, 
    age, course, email, 
    phone, selectedOption, collegeName, grade, section, schoolName, companyName, role, edu,
    formattedData,
    selectedAnswersPartI,
    selectedAnswersPartII,
    selectedAnswersPartIII

 }) {
    const [isSubmitting, setIsSubmitting] = React.useState(false); 

    const handleSubmitTest = async () => {

    if (Object.keys(selectedAnswersPartI).length === 0) {
        toast.dismiss(TOAST_ID);
        toast.error("Part I - Incomplete", {
            style: {
                display: 'flex',
                background: '#fff',
                color: '#000',
                padding: '10px 14px',
                borderRadius: '10px',
                justifyContent: 'center',
                alignItems: 'center',
                textAlign: 'center',
            },
            position: "top-center",
            autoClose: 1000,
        });
        return;
    }

    if (Object.keys(selectedAnswersPartII).length === 0) {
        toast.dismiss(TOAST_ID);
        toast.error("Part II - Incomplete", {
            style: {
                display: 'flex',
                background: '#fff',
                color: '#000',
                padding: '10px 14px',
                borderRadius: '10px',
                justifyContent: 'center',
                alignItems: 'center',
                textAlign: 'center',
            },
            position: "top-center",
            autoClose: 1000,
        });
        return;
    }

    if (selectedAnswersPartIII.length === 0) {
        toast.dismiss(TOAST_ID);
        toast.error("Part III - Incomplete", {
            style: {
                display: 'flex',
                background: '#fff',
                color: '#000',
                padding: '10px 14px',
                borderRadius: '10px',
                justifyContent: 'center',
                alignItems: 'center',
                textAlign: 'center',
            },
            position: "top-center",
            autoClose: 1000,
        });
        return;
    }

        setIsSubmitting(true); 
        try{

            const response = await submitTestAPI(name, age, course, email,phone, selectedOption, collegeName, grade, section,
                 schoolName, companyName, role, edu, formattedData);
            
            toast.dismiss(TOAST_ID);

            toast.success("Test Submitted Successfully", {
                toastId: TOAST_ID,
                style: {
                    display: 'flex',
                    background: '#f2f0f0',
                    color: '#141414',
                    padding: '10px 14px',
                    borderRadius: '10px',
                    justifyContent: 'center',
                    alignItems: 'center',
                    textAlign: 'center',
                },
                position: "top-center",
                autoClose: 1000,
            });

              sessionStorage.setItem('resultsData', JSON.stringify(response.data));

            
             setTimeout(() => {
               setOpen(false); 
                 window.location.href='/yourresults'; 

             }, 1000); 
         } catch (error) {
             const errorMessage = error.response?.data?.message || "An unexpected error occurred.";
             console.log("Error occurred:", errorMessage);

            toast.error(errorMessage, {
                style: {
                    display: 'flex',
                    background: '#fff',
                    color: '#000',
                    padding: '10px 14px',
                    borderRadius: '10px',
                    justifyContent: 'center',
                    alignItems: 'center',
                    textAlign: 'center',
                },
                position: "top-center",
                autoClose: 1000,
            });
         } finally {
             setIsSubmitting(false); // Reset loading state
         }
    };

    const handleClose = () => {
        setOpen(false); 
    };

    return (
        <React.Fragment>
            <Dialog
                open={open}
                TransitionComponent={Transition}
                keepMounted
                onClose={(event, reason) => {
                    if (reason === "backdropClick") {
                        return; // Prevent dialog from closing on outside click
                    }
                    handleClose(); // Handle other close actions
                }}                
                aria-describedby="alert-dialog-slide-description"
            >
                <DialogTitle
                    sx={{
                        fontSize: "20px",
                        fontWeight: "700",
                    }}
                >
                    {"Submit Test"}
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-slide-description">
                        Are you sure you want to submit your results?
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose} aria-label="Cancel submission" disabled={isSubmitting}>
                        Cancel
                    </Button>
                    <Button
                        onClick={handleSubmitTest}
                        disabled={isSubmitting}
                        aria-label="Submit test"
                    >
                        {isSubmitting ? "Submitting..." : "Submit"} 
                    </Button>
                </DialogActions>
            </Dialog>
            <ToastContainer />
        </React.Fragment>
    );
}
